<template>
    <div id="perfil">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div id="profile-page" class="section">
                    <div class="row">
                        <TituloPagina class="ml-1" titulo="Dados Pessoais" />
                        <div class="col m12 s12 l3">
                            <!-- profile-page-header -->
                            <div id="profile-page-header" class="card padding-6">
                                <div class="centralizar pb-7">
                                    <div style="position:relative" id="card-profile">
                                        <a id="delete-avatar" @click.prevent="excluirAvatar()" v-if="imgDataUrl">
                                            <i class="material-icons icon-close">close</i>
                                        </a>
                                        <div id="card-profile-image-action" class="card-profile-image-action"
                                                @click="showModalAvatar()">
                                                <i
                                                    @click="showModalAvatar()"
                                                    style="font-size: 50px; text-align: center"
                                                    class="responsive-img activator white-text material-icons"
                                                >
                                                    photo
                                                </i>

                                                    <span class="white-text">Trocar</span>
                                        </div>
                                        <img
                                            v-if="imgDataUrl"
                                            :src="imgDataUrl"
                                            class="circle responsive-img activator card-profile-image"
                                            style="height: 150px;"

                                        >
                                        <div class="white-text circle" style="background-color:#fafafa; display: flex; justify-content: center; align-items: center; height: 150px; width:150px; text-align: center">
                                            <i
                                            v-if="!imgDataUrl"
                                            style="color: #cfcfcf; font-size: 80px; text-align: center"
                                            class="card-profile-image responsive-img activator material-icons circle"
                                            >
                                            person
                                            </i>

                                        </div>
                                    </div>

                                </div>
                                <div class="card-list s12">
                                        <div class="card-title centralizar">
                                            <span>{{ nome }}</span>
                                        </div>
                                        <div class="card-subtitle centralizar pb-7">
                                            <span class="">{{ cargo }}</span>
                                        </div>
                                    <ul class="collection">
                                        <li class="collection-item">
                                            <div>Agência
                                                <div class="secondary-content card-subtitle">
                                                    {{ agencia }}
                                                </div>
                                            </div>
                                        </li>
                                        <li class="collection-item">
                                            <div>Telefone
                                                <div class="secondary-content card-subtitle">
                                                    {{ telefone }}
                                                </div>
                                            </div>
                                        </li>
                                        <li class="collection-item">
                                            <div>Email
                                                <div class="secondary-content card-subtitle">
                                                    {{ email }}
                                                </div>
                                            </div>
                                        </li>
                                        <li class="collection-item">
                                            <div>Cidade
                                                <div class="secondary-content card-subtitle" style="text-transform: capitalize;">
                                                    {{ cidade }}
                                                </div>
                                            </div>
                                        </li>
                                        <li class="collection-item">
                                            <div>Estado
                                                <div class="secondary-content card-subtitle">
                                                    {{ estado }}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <!--<div class="card-content">
                                    <div class="row pt-2">
                                        <div class="">
                                            <h4 class="card-title grey-text text-darken-4">{{ nome }}</h4>
                                            <p class="medium-small grey-text">{{ cargo }}</p>
                                        </div>
                                        <div class="col s12 m2 center-align">
                                            <h4 class="card-title grey-text text-darken-4">
                                                <i class="material-icons">pin_drop</i>
                                            </h4>
                                            <p class="medium-small grey-text">{{ agencia }}</p>
                                        </div>
                                        <div class="col s12 m2 center-align">
                                            <h4 class="card-title grey-text text-darken-4">
                                                <i class="material-icons">phone</i>
                                            </h4>
                                            <p class="medium-small grey-text">{{ telefone }}</p>
                                        </div>
                                        <div class="col s12 m2 center-align">
                                            <h4 class="card-title grey-text text-darken-4">
                                                <i class="material-icons">email</i>
                                            </h4>
                                            <p
                                                class="medium-small grey-text"
                                                style="word-wrap: break-word;"
                                            >
                                                {{ email }}
                                            </p>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <!-- profile-page-header end -->
                            <div>
                                 <!-- <div class="row">
                                    <div class="col m12">
                                        <button
                                            @click="show=true"
                                            class="btn waves-effect waves-light cyan"
                                        >
                                            Trocar avatar
                                        </button>
                                    </div>
                                </div>-->
                                <my-upload field="img"
                                   @crop-success="cropSuccess"
                                   @crop-upload-success="cropUploadSuccess"
                                   @crop-upload-fail="cropUploadFail"
                                   v-model="show"
                                   :width="300"
                                   :height="300"
                                   :url="url"
                                   :params="params"
                                   :headers="headers"
                                   img-format="png"
                                   lang-type="pt-br"
                                >
                                </my-upload>
                            </div>
                        </div>
                        <div class="col s12 m12 l9">
                            <div class="card-panel">
                                <div class="row">
                                    <form class="col s12" v-on:submit.prevent="save">
                                        <div class="row">
                                            <div class="input-field col s12">
                                                <input placeholder="John Doe" id="nome" type="text" v-model="nome">
                                                <label for="nome" :class="checkValue(nome)">Nome</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="input-field col s6">
                                                <input placeholder="john@domainname.com" id="email" type="email" v-model="email">
                                                <label for="email" :class="checkValue(email)">Email</label>
                                            </div>
                                            <div class="input-field col s6">
                                                <input id="username" type="text" v-model="usuario_username">
                                                <label for="username" :class="checkValue(usuario_username)">Login</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="input-field col s12">
                                                <masked-input type="text" id="telefone" v-model="telefone" mask="(11)11111-1111"/>
                                                <label for="telefone" :class="checkValue(telefone)">Telefone</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="input-field col s12">
                                                <input placeholder="Trocar de Senha" id="senha" type="password" v-model="senha">
                                                <label for="senha" class="active">Senha</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col s12 m12">
                                                <label for="estado">Estado</label>
                                                <select class="browser-default" v-model="estado" id="estado">
                                                    <option value="" disabled selected>Selecione o estado ...</option>
                                                    <option :value="estado.sigla" v-for="estado in estadosCidades.estados">{{ estado.nome }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col s12 m12">
                                                <label for="estado">Cidade</label>
                                                <select class="browser-default" v-model="cidade" id="cidade">
                                                    <option value="" disabled selected>Selecione a cidade ...</option>
                                                    <option :value="cidade.toLowerCase()" v-for="cidade in getCidades()">{{ cidade }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row">
                                                <div class="input-field col s12">
                                                    <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                        Salvar
                                                        <!-- <i class="material-icons right">send</i> -->
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>
<style lang="scss">
    #profile-page-header img{
        height: 150px;
        width: 150px;
    }
    .avatar-profile:hover{
        background-color: #1eb6dc !important;
        cursor: pointer;
    }
    #profile-page-header .card-list .collection{
        border: none !important;
    }
    #profile-page-header .card-subtitle{
        color: #b5b5b5;
        text-align: right;
    }
    .centralizar{
        display: flex;
        justify-content: center;
        align-items: center;
    }

     .icon-action{
        position: absolute;
        top: 0;
        right: 0;
    }
    .card-user{
        position: relative;
    }
    .card.card-profile {
        margin-top: 0;
    }
    .card-personal{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column;
    }
    .card-personal .card-title{
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .card-personal .card-actions{
        margin-top: 20px;
        display: flex;
    }
    .card-personal .card-actions .btn{
        padding: 0 1rem;
        margin: .2rem;
    }

    .collection{
        margin-top:30px;
    }

    .card-personal .collection-item{
        padding-left: 0;
        padding-right: 0;
        word-wrap: break-word;
        word-break: break-all;
    }
    .card-personal .card-subtitle{
        color: #b5b5b5;
        text-align: right;
    }
    .card-personal .collection{
        border-top: 0;
        border-bottom: 0;
        border-left: 0;
        border-right: 0;
    }
    .card-personal .collection-item-custom{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        background-color: #fff;
        line-height: 1.5rem;
        padding: 10px 0;
        margin: 0;
        border-bottom: 1px solid #e0e0e0;
        align-content: center;
    }
     .data-criacao{
         border: none !important;
     }


    .card-personal .collection-item-custom span{
        width: 47px;
    }
    .card-personal .collection-item-custom p{
        color: #b6b6b6;
        width: calc(100% - 95px);
        margin-left: 48px;
        text-align: right;
        height: auto;
        word-wrap: break-word;
    }
    .card-personal .collection-item-custom-big span{
        width: 110px;
    }
    .card-personal .collection-item-custom-big p{
        width: calc(100% - 165px);
        margin-left: 50px;
    }
    #InformacoesAdicionais #profile-card .card-profile-image {
        width: 70px;
        height: 70px;
        position: absolute;
        top: 10px;
        z-index: 1;
        cursor: pointer;
        right: 10px;

    }

    .card-profile-image-action{
        opacity: 0;
        position: absolute;
        height: 150px;
        width: 150px;
        border-radius: 50%;
        background-color: #1eb6dc;
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        z-index: 2;

    }
    .card-profile-image-action:hover{
        opacity: .7;
    }

    #InformacoesAdicionais .card-profile-image {
        cursor: pointer;
    }

    .collection-item.avatar img {
        border-radius: 50%;
        position: absolute;
        width: 42px;
        height: 42px;
        overflow: hidden;
        left: 15px;
    }
    #profile-page-header .card-profile-image{
        top: 38px;
        left: 20px;
    }
    #profile-page-header img{
        top: 0 !important;
        left: 0 !important;
        height: 100% !important;
        width: 100% !important;
    }
    .center, .center-align {
    text-align: center;
    }

    #delete-avatar{
        position: absolute;
        right: 0;
        top: -10px;
        color: #222;
        cursor: pointer;

        .icon-close{
            font-size: 25px;
            font-weight: bold;
        }


    }

</style>

<script>
    import myUpload from 'vue-image-crop-upload';
    //import * as estadosCidadesJSON from '../../constants/estadosCidades';
    import TituloPagina from '@/components/common/TituloPagina'
    import Auth from '../../store/auth';
    import { get, post, api } from '@/helpers/api';
    import MaskedInput from 'vue-masked-input';
    import Message from '@/helpers/message';
    import {getUrl} from "../../helpers/api";
    import { DONO, GERENTE, CORRETOR, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import Events from '@/helpers/events';


    export default {
        components: {
            myUpload,
            MaskedInput,
            TituloPagina
        },
        data: () => ({
            usuario_username: '',
            nome: '',
            avatar: '',
            email: '',
            senha: '',
            telefone: '',
            pais: '',
            estado: '',
            cidade: '',
            cargo: '',
            agencia: '',
            descricao: '',
            leadsIndicados: 0,
            dataAniversario: '',
            estadosCidades: {},
            imgDataUrl: '',
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoParceiro: null,
            params: {
                name: 'avatar'
            },
            show: false,
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.getItem('api_token')}`
            },
            url: ''
        }),
        created: async function() {
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.url = getUrl('funcionario/upload-imagem');
            let self = this;
            self.showLoading();

            api.get('funcionario/show-logged').then(function (responseData) {
                let response = responseData.data.result.data;
                self.nome = response.pessoa ? response.pessoa.pessoa_nome : '';
                self.email = response.pessoa ? response.pessoa.pessoa_email : '';
                self.senha = '';
                self.cargo = response.funcionario_cargo ?
                    response.funcionario_cargo.funcionario_cargo_nome :
                    '';
                self.telefone = response.pessoa ? response.pessoa.pessoa_celular : '';
                self.estado = response.pessoa.endereco && response.pessoa.endereco.endereco_estado ? response.pessoa.endereco.endereco_estado : '';
                self.cidade = response.pessoa.endereco && response.pessoa.endereco.endereco_cidade ? response.pessoa.endereco.endereco_cidade.toLowerCase() : '';
                self.agencia = response.empresa ? response.empresas.map( e => e.empresa_nome_fantasia).join(', ') : '';
                self.leadsIndicados = 900;
                self.dataAniversario = response.pessoa.pessoa_data_nascimento ? moment(response.pessoa.pessoa_data_nascimento).format('YYYY/MM/DD') : '';
                self.avatar = response.pessoa ? response.pessoa.pessoa_avatar : '';
                self.imgDataUrl = response.pessoa ? response.pessoa.pessoa_avatar_url : '';

                self.usuario_username = response.pessoa.usuario.usuario_username;

                self.hideLoading();
            });

            this.estadosCidades = await import('../../constants/estadosCidades');
        },
        methods: {
            save() {
                let self = this;
                self.showLoading();
                api.post('funcionario/editar-logado', {
                    nome: this.nome,
                    email: this.email,
                    senha: this.senha,
                    telefone: this.removerCaracteres(this.telefone),
                    estado: this.estado,
                    cidade: this.cidade,
                    usuario_username: this.usuario_username,
                }).then(function (responseData) {
                    let response = responseData.data.result.data;
                    self.nome = response.pessoa.pessoa_nome;
                    self.email = response.pessoa.pessoa_email;
                    self.senha = '';
                    self.cargo = response.funcionario_cargo.funcionario_cargo_nome;
                    self.telefone = response.pessoa.pessoa_celular;
                    self.estado = response.pessoa.endereco.endereco_estado;
                    self.cidade = response.pessoa.endereco.endereco_cidade ? response.pessoa.endereco.endereco_cidade.toLowerCase() : '';
                    self.agencia = response.empresa.empresa_nome_fantasia;
                    self.leadsIndicados = 900;
                    self.dataAniversario = '31/05/1989';
                    self.avatar = response.pessoa.pessoa_avatar;
                    Message.messageSuccess('Salvo com sucesso.');
                    self.hideLoading();
                }).catch(function (data) {
                    self.hideLoading();
                });
            },
            getCidades: function () {
                if (!this.estado) {
                    return [];
                }

                let self = this;
                let items = [];
                this.estadosCidades.estados.forEach(function (obj) {
                    if (obj.sigla === self.estado) {
                        items = obj.cidades;
                    }
                });
                return items;
            },
            cropSuccess(imgDataUrl, field){
                // console.log('-------- crop success --------');
                this.imgDataUrl = imgDataUrl;
                Events.avatarChange(imgDataUrl);
                Auth.setAvatarUsuario(imgDataUrl);
            },
            cropUploadSuccess(jsonData, field){
                this.avatar = jsonData.result.data;
                this.show = false;
            },
            cropUploadFail(status, field){
                this.show = false;
            },
            checkValue(value) {
                if (value !== '') {
                    return 'active';
                }
                return '';
            },
            showLoading () {
                this.$parent.$emit('showLoading', true);
            },
            hideLoading () {
                this.$parent.$emit('showLoading', false);
            },
            showModalAvatar() {
                this.show = true;
            },
            removerCaracteres(string) {
                if (string === '' || string === null) {
                    return '';
                }
                let stringReplace;
                stringReplace = string.split('(').join('');
                stringReplace = stringReplace.split(')').join('');
                stringReplace = stringReplace.split('-').join('');
                stringReplace = stringReplace.split('.').join('');
                stringReplace = stringReplace.split('_').join('');
                return stringReplace;
            },


            async excluirAvatar() {
                await api.delete('funcionario/remover-avatar');
                this.imgDataUrl = '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/perfil/Perfil.vue